<template>
  <div class="flex gap-5 self-center mt-7 w-10/12 max-md:flex-wrap max-md:max-w-full">
    <img loading="lazy" :src="imageSrc" class="flex self-left mr-12 shrink-0 max-w-full aspect-[1.85] w-[130px]" />
    <div class="flex flex-auto gap-4 justify-between items-start pr-4 my-auto max-md:flex-wrap max-md:max-w-full">
      <div v-for="item in items" :key="item.name" class="self-stretch">
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductRow',
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(item => 'name' in item && 'value' in item);
      }
    }
  }
};
</script>

<style scoped>
/* 添加你的样式 */
</style>
